<template>
    <div class="w-100">
        {{ message }}
        <pc-input
            v-model="inputtedConfirmation"
            data-test-role="textConfirmationDialog"
            class="mt-3"
            v-bind:placeholder="requiredConfirmation"
            v-bind:validator="confirmActionValidator"
            v-bind:label="confirmationInputLabel"
            immediate-validation
            v-on:validated="onValidated" />
        <div class="modal-footer mt-4 pe-2 mx-n3 pb-0">
            <pc-button-row>
                <template v-slot:right>
                    <pc-button v-on:click="cancelClick">
                        {{ cancelText }}
                    </pc-button>
                    <pc-button
                        primary
                        v-bind:disabled="!isValidState"
                        v-on:click="confirmClick">
                        {{ okText }}
                    </pc-button>
                </template>
            </pc-button-row>
        </div>
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS as COMMON_KEYS, NAMESPACE as COMMON_NAMESPACE } from "I18n/common.i18n";
    import { KEYS, NAMESPACE } from "./i18n/textConfirmationDialog.i18n";
    import { getValidator, VALIDATOR_TYPES } from "Validation/validator";

    export const TEXT_CONFIRMATION_RESULT = {
        cancel: "Cancel",
        ok: "Ok"
    };
    export default {
        props: {
            message: { type: String, required: true },
            requiredConfirmation: { type: String, required: true }
        },
        data() {
            return {
                inputtedConfirmation: null,
                isValidState: false
            };
        },
        computed: {
            confirmActionValidator() {
                return getValidator(this.$app, {
                    type: VALIDATOR_TYPES.custom,
                    validate: this._doesConfirmationMatch,
                    errorMsg: this.inputTextDoesNotMatchConfirmationMessage
                });
            },
            ...mapI18n(COMMON_KEYS, COMMON_NAMESPACE),
            ...mapI18n(
                {
                    ...KEYS,
                    confirmationInputLabel() {
                        return {
                            key: KEYS.inputLabelBase,
                            values: { requiredConfirmation: this.requiredConfirmation }
                        };
                    }
                },
                NAMESPACE
            )
        },
        methods: {
            _doesConfirmationMatch(inputtedConfirmationValue) {
                const lowerCaseRequiredConfirmation = this.requiredConfirmation.toLowerCase();
                const lowerCaseInputtedConfirmation = inputtedConfirmationValue?.toLowerCase();
                return lowerCaseInputtedConfirmation === lowerCaseRequiredConfirmation;
            },
            onValidated(event) {
                this.isValidState = !event.hasError;
            },
            confirmClick() {
                this.$app.closeDialog({ resolve: true, resolveValue: TEXT_CONFIRMATION_RESULT.ok });
            },
            cancelClick() {
                this.$app.closeDialog({ resolve: true, resolveValue: TEXT_CONFIRMATION_RESULT.cancel });
            }
        }
    };
</script>
